import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useState } from 'react';
import { useEffect } from 'react';
var defaultProps = {
  current: 1,
  total: 4,
  next: 2,
  prev: ''
};
var Pagination = function Pagination(_ref) {
  var current = _ref.current,
    total = _ref.total,
    next = _ref.next,
    prev = _ref.prev;
  var _useState = useState(""),
    nextLink = _useState[0],
    setNextLink = _useState[1];
  var _useState2 = useState(""),
    prevLink = _useState2[0],
    setPrevLink = _useState2[1];
  useEffect(function () {
    setNextLink(getLink(next));
  }, [next]);
  useEffect(function () {
    setPrevLink(getLink(prev));
  }, [prev]);
  var buttonHandler = function buttonHandler(e, url) {
    if (!url) {
      e.preventDefault();
    }
    window.location.href = url;
  };
  var getLink = function getLink(newPage) {
    if (!newPage || typeof window === "undefined") {
      return "";
    }
    var _window = window,
      href = _window.location.href;
    var param = encodeURIComponent('page');
    var anchorEl = document.createElement('a');
    var regex = /(?:\?|&amp;|&)+([^=]+)(?:=([^&]*))*/g;
    var match;
    var str = [];
    anchorEl.href = href;
    while (match = regex.exec(anchorEl.search)) {
      if (param !== match[1]) {
        str.push("" + match[1] + (match[2] ? "=" + match[2] : ''));
      }
    }

    // If we are navigating back to page 1, then we strip the param
    // from the URL altogether
    if (newPage !== 1) {
      str.push(param + (newPage ? "=" + encodeURIComponent(newPage) : ''));
    }
    anchorEl.search = str.join('&');
    return anchorEl.href;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "gatsby-pagination container"
  }, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: "gatsby-pagination__inner"
  }, /*#__PURE__*/React.createElement("p", {
    className: "gatsby-pagination__label"
  }, /*#__PURE__*/React.createElement("b", null, "Page ", current), ' ', "of ", total), /*#__PURE__*/React.createElement("a", {
    href: prev ? prevLink : "#",
    className: "gatsby-pagination__button ml-3 " + (!prev ? 'disabled' : '') + " ",
    disabled: !prev,
    onClick: function onClick(e) {
      return buttonHandler(e, prevLink);
    },
    "data-testid": "prev-button"
  }, /*#__PURE__*/React.createElement(FaChevronLeft, {
    className: "gatsby-pagination__icon",
    size: 32
  })), /*#__PURE__*/React.createElement("p", {
    className: "gatsby-pagination__current ml-2",
    "data-testid": "current-page"
  }, current), /*#__PURE__*/React.createElement("a", {
    href: next ? nextLink : "#",
    className: "gatsby-pagination__button ml-2 " + (!next ? 'disabled' : '') + " ",
    disabled: !next,
    onClick: function onClick(e) {
      return buttonHandler(e, nextLink);
    },
    "data-testid": "next-button"
  }, /*#__PURE__*/React.createElement(FaChevronRight, {
    className: "gatsby-pagination__icon",
    size: 32
  }))));
};
Pagination.defaultProps = defaultProps;
export { Pagination };